<h2 mat-dialog-title>
  <span>{{ 'TRANS__CREATE_OBJECT_DIALOG__TITLE' | translate }}</span>
</h2>

<mat-dialog-content>
  <p>
    {{ 'TRANS__CREATE_OBJECT_DIALOG__SUBTITLE' | translate }}
  </p>

  <mat-accordion displayMode="flat" class="create-object-accordion">
    @for (group of operationGroups; track $index) {
      <mat-expansion-panel class="create-object-accordion__panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ group.label | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="create-object-accordion__buttons">
          <ng-container
            *ngTemplateOutlet="operationItems; context: { $implicit: group.items }"
          ></ng-container>
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>

  <ng-template #operationItems let-items>
    @for (item of items; track $index; let last = $last) {
      <ng-container>
        <div class="create-object-accordion__button-row">
          <button
            matButton="text"
            type="button"
            class="create-object-accordion__action"
            (click)="onLeafNodeClick($event, item)"
          >
            @if (item.icon) {
              <mat-icon
                matButtonIcon
                class="material-symbols-outlined create-object-accordion__action-icon"
                aria-hidden="true"
              >
                {{ item.icon }}
              </mat-icon>
            }

            <span class="create-object-accordion__action-label">
            {{ item.label | translate }}
          </span>
          </button>

          @if (item.tooltip) {
            <button
              matIconButton
              type="button"
              class="create-object-accordion__tooltip"
              [matTooltip]="item.tooltip | translate"
              (click)="$event.stopPropagation()"
              [attr.aria-label]="item.tooltip | translate"
            >
              <mat-icon
                matButtonIcon
                class="material-symbols-outlined"
                aria-hidden="true"
              >
                help
              </mat-icon>
            </button>
          }
        </div>

        @if (item.children?.length) {
          <div
            class="create-object-accordion__buttons"
          >
            <ng-container
              *ngTemplateOutlet="operationItems; context: { $implicit: item.children }"
            ></ng-container>
          </div>
        }

        @if (!last) {
          <mat-divider></mat-divider>
        }
      </ng-container>
    }
  </ng-template>
</mat-dialog-content>
